<template>
    <div class="card m-2 bg-light artikelheader">
        <img :src="require('../assets/'+img)" class="card-img-top m-3 mx-auto" alt="...">
        <div class="card-body">
            <p class="card-text">{{titel}}</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Artikelheader',
        props: ["titel", "img"],
    }
</script>
<style scoped>
    .artikelheader{
        max-width:350px;
        min-width: 300px;
        cursor:pointer;
    }
</style>